var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { BasicButton, getButtonColors, getReverseButtonColors, getButtonSize, } from '../styled';
export const BaseDangerButton = css `
  ${BasicButton};
  ${(props) => props.reverse === 'true'
    ? getReverseButtonColors('Danger')
    : getButtonColors('Danger')};
  ${(props) => getButtonSize(props.size)};
`;
export const DangerButtonLink = styled(Link) `
  ${BaseDangerButton};
`;
export const DangerButtonExternalLink = styled.a `
  ${BaseDangerButton};
`;
const Danger = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return props.external ? (React.createElement(DangerButtonExternalLink, Object.assign({ href: props.url, size: props.size, reverse: props.reverse }, props.buttonProps), children)) : (React.createElement(DangerButtonLink, Object.assign({ to: props.url, size: props.size, reverse: props.reverse }, props.buttonProps), children));
};
Danger.defaultProps = {
    size: 'Standard',
    external: false,
    reverse: 'false',
};
export default Danger;
